import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProjectregelStatusHistorie } from '../dto/projectregel-status-historie';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ProjectregelStatusHistorieService extends CrudService<ProjectregelStatusHistorie> {

    constructor(injector: Injector) { super(ProjectregelStatusHistorie, injector); }

}
